// vim: set ts=2 sts=2 sw=2 et:
//
// Aviso al operador cuando entra un veredicto y hay que tocar "Siguiente" mientras la ventana de
// OpenLifter no está a la vista (otra pestaña u otra aplicación). Notificación del sistema: necesita
// permiso del navegador y un contexto seguro (https o localhost).

const notifications = (): typeof Notification | null =>
  typeof window !== "undefined" && typeof window.Notification === "function" ? window.Notification : null;

/** Pide permiso una sola vez. Llamar desde un click del operador: algunos navegadores lo exigen. */
export const requestOperatorNotificationPermission = (): void => {
  const api = notifications();
  if (api === null || api.permission !== "default") return;
  try {
    const result = api.requestPermission() as Promise<NotificationPermission> | undefined;
    result?.catch(() => undefined);
  } catch (_error) {
    // Navegadores viejos o sin soporte: el aviso visual de la barra alcanza.
  }
};

const isOperatorWindowInactive = (): boolean =>
  typeof document !== "undefined" && (document.hidden || !document.hasFocus());

/** Muestra el aviso si hay permiso y la ventana no está a la vista; si no, no hace nada. */
export const notifyOperator = (title: string, body: string): Notification | null => {
  const api = notifications();
  if (api === null || api.permission !== "granted" || !isOperatorWindowInactive()) return null;
  try {
    // El mismo tag reemplaza un aviso anterior en vez de apilarlos.
    const notification = new api(title, { body, tag: "wrpf-siguiente" });
    notification.onclick = () => {
      window.focus();
      notification.close();
    };
    return notification;
  } catch (_error) {
    // Algunos navegadores (Chrome en Android) solo notifican desde un service worker.
    return null;
  }
};
